import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { ErrorBoundaryWrapper as ErrorBoundary } from 'components/ErrorBoundary';
import { Footer } from 'components/Footer';
import { SearchResults } from 'components/SearchResults';
import { useDefaultLayout } from 'hooks/useDefaultLayout';
import useSapiSearch from 'modules/sapiSearch/useSapiSearch';
import { getError } from 'modules/search/selectors';
import { LayoutType } from 'modules/search/types';
import OpacityAnimation from '@daedalus/atlas/helpers/OpacityAnimation';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
const VerticalFilledSection = /*#__PURE__*/styled('div')({
  name: "VerticalFilledSection",
  class: "v1c8kbvt",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1vviifd",
  propsAsIs: false
});
const ErrorElement = /*#__PURE__*/styled('div')({
  name: "ErrorElement",
  class: "e3cmmls",
  propsAsIs: false
});
const FooterContainer = () => {
  const {
    layout
  } = useDefaultLayout();
  const forcedLayout = layout === LayoutType.SPLIT ? 'compact' : undefined;
  return <>
      {/*
        Delaying showing the footer until all the skeletons are showing.
        Not doing this will make the footer jump down, and hurt really badly
        our CLS.
       */}
      <OpacityAnimation delay={1500}>
        <FooterWrapper>
          <Footer forcedLayout={forcedLayout} />
        </FooterWrapper>
      </OpacityAnimation>
    </>;
};
const FooterWrapper = /*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "f48oycc",
  propsAsIs: false
});
const Search = () => {
  const error = useSelector(getError);
  const {
    isSapiInitialized
  } = useSapiSearch();
  const hasError = error || !isSapiInitialized();
  return <>
      <VerticalFilledSection>
        <ErrorBoundary>
          <OpacityAnimation ignorePosition>
            <ContentWrapper>
              {hasError ?
            // This error is never shown, because the ErrorBoundary component already shows an error message higher up in the tree
            <ErrorElement>
                  <FormattedMessageWrapper id="searchError" defaultMessage="Search error:" />{' '}
                  {error}
                </ErrorElement> : <SearchResults />}
            </ContentWrapper>
          </OpacityAnimation>
        </ErrorBoundary>
      </VerticalFilledSection>
      <FooterContainer />
    </>;
};
export default Search;

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");